/* it.ts */
/* Localization for Italian ~ Localizzazione italiana 🍕*/

import { generateLocale } from './generate.js';

export default generateLocale([
  'Nickname',
  'Il nickname non può avere meno di 3 caratteri.',
  'E-mail',
  'Per favore conferma il tuo indirizzo e-mail.',
  'Sito web',
  'Facoltativo',
  'Scrivi un commento...',
  'Ancora nessun commento.',
  'Invia',
  'Mi piace',
  'Annulla mi piace',
  'Rispondi',
  'Annulla risposta',
  'Commenti',
  'Aggiorna',
  'Carica altri...',
  'Anteprima',
  'Emoji',
  'Carica immagine',
  'secondi fa',
  'minuti fa',
  'ore fa',
  'giorni fa',
  'adesso',
  'Caricamento in corso...',
  'Accedi',
  'Esci',
  'Admin',
  'In evidenza',
  'Parole',
  'Inserisci un commento tra $0 e $1 parole!\n Numero attuale di parole: $2',
  'Anonimo',
  'Nano',
  'Hobbit',
  'Ent',
  'Mago',
  'Elfo',
  'Maiar',
  'GIF',
  'Cerca GIF',
  'Profilo',
  'Approvato',
  'In attesa',
  'Spam',
  'Rimuovi evidenza',
  'Più vecchi',
  'Più recenti',
  'Più popolari',
  'Cosa ne pensi?',
  "Il tuo commento è in fase di revisione ed è attualmente visibile solo a te. Sarà visibile pubblicamente dopo l'approvazione.",
  'Iscriviti ai commenti di questo post',
  'Iscriviti ai commenti di questo sito',
  'Iscriviti alle risposte dei tuoi commenti',
]);
